import { mergeAttributes, Node } from '@tiptap/core';
import { COLUMN_NODE_NAME } from './columns.model';

const columnClassName = 'column-block';

export const ColumnExtension = () => {
  return Node.create({
    name: COLUMN_NODE_NAME,
    content: 'block+',
    defining: true,
    isolating: true,
    selectable: false,
    draggable: false,

    parseHTML() {
      return [{ tag: `div.${columnClassName}` }];
    },

    renderHTML({ HTMLAttributes }) {
      return ['div', mergeAttributes({ class: columnClassName }, HTMLAttributes), 0];
    },
  });
};
